import { API_BASE_URL } from "./constants";
import { getCookie } from "./cookies";

/**
 * Custom function to retrieve a cookie value by name.
 * @param {string} name - The name of the cookie.
 * @returns {string|null} The cookie value, or null if not found.
 */

// Helper function to perform API calls.
const apiCall = async (endpoint, method, payload) => {
  // Retrieve the JWT from the cookie named "userToken"
  const token = getCookie('userToken');

  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  };

  if (payload && method !== 'GET' && method !== 'DELETE') {
    options.body = JSON.stringify(payload);
  }

  // Prepend the API_BASE_URL to the endpoint.
  const response = await fetch(`${API_BASE_URL}${endpoint}`, options);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'API call failed');
  }

  return data;
};

export default apiCall;